export enum NewChaseHedisActiveScreen {
    PROJECT = 0,
    MEMBER = 1,
    ADDRESS = 2,
    PROVIDER = 3,
    REVIEW = 4,
    CONFIRMATION = 5,
  }
